import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

export type HeaderToolVariant = "default" | "primary" | "active" | "amber";

const VARIANT_CLASS: Record<HeaderToolVariant, string> = {
  default:
    "bg-background text-muted-foreground ring-border/70 hover:bg-muted/60 hover:text-foreground",
  primary:
    "bg-primary/8 text-primary ring-primary/15 hover:bg-primary hover:text-primary-foreground hover:ring-primary/30",
  active: "bg-primary/10 text-primary ring-primary/25 hover:bg-primary/15",
  amber:
    "bg-amber-500/10 text-amber-700 ring-amber-500/20 hover:bg-amber-500 hover:text-white dark:text-amber-400",
};

export const HEADER_TOOL_BTN_CLASS =
  "flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ring-1 transition-all active:scale-[0.97] disabled:pointer-events-none disabled:opacity-50";

export const HEADER_TOOL_ICON_CLASS = "h-5 w-5";

interface HeaderToolButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: HeaderToolVariant;
  children: ReactNode;
}

export function HeaderToolButton({
  variant = "default",
  className,
  children,
  type = "button",
  ...props
}: HeaderToolButtonProps) {
  return (
    <button
      type={type}
      className={cn(HEADER_TOOL_BTN_CLASS, VARIANT_CLASS[variant], className)}
      {...props}
    >
      {children}
    </button>
  );
}
